{
  "common": {
    "title": "Common Daas: Customer support tool",
    "toFrontPageButton": "Back to customer list",
    "orderStatus": {
      "select": "Select order status",
      "cannotBeProcessed": "Cannot be processed",
      "processingOrder": "Processing order",
      "approved": "Approved",
      "pendingApproval": "Pending approval",
      "delivered": "Delivered",
      "financingDeclined": "Financing declined",
      "approvalDeclined": "Approval declined",
      "cancelled": "Cancelled",
      "returned": "Returned",
      "all": "All"
    }
  },
  "ordersPage": {
    "title": "Orders",
    "menuItemLabel": "Orders",
    "cardTitle": "Orders with status",
    "tagCheck": "Check",
    "tagLoading": "Loading...",
    "table": {
      "noDataText": "No orders with selected status",
      "errorText": "Failed to load orders",
      "headerOrganization": "Organization",
      "headerOrderId": "Order ID",
      "headerColtOrderId": "COLT order ID",
      "headerCreated": "Created",
      "rowButtonText": "Show"
    }
  },
  "returnPackageOrdersPage": {
    "title": "Return package orders",
    "menuItemLabel": "Return package orders",
    "cardTitle": "Return package orders with status",
    "tagCheck": "Check",
    "tagLoading": "Loading...",
    "table": {
      "noDataText": "No return package orders with selected status",
      "errorText": "Failed to load return package orders",
      "headerOrganization": "Organization",
      "headerOrderId": "Return package order ID",
      "headerColtOrderId": "COLT order ID",
      "headerCreated": "Created",
      "rowButtonText": "Show device"
    }
  },
  "devicesPage": {
    "title": "Devices",
    "menuItemLabel": "Devices",
    "cardTitle": "Devices with Telia Finance status",
    "tagCheck": "Check",
    "tagLoading": "Loading...",
    "table": {
      "noDataText": "No devices with selected status",
      "errorText": "Failed to load devices",
      "headerOrganization": "Organization",
      "headerName": "Name",
      "headerUser": "User",
      "rowButtonText": "Show"
    },
    "financeSyncStatus": {
      "select": "Select Telia Finance status",
      "error": "Sync failed",
      "pending": "Sync pending",
      "ok": "Sync not needed",
      "all": "All"
    }
  },
  "availabilityPage": {
    "title": "Availability",
    "menuItemLabel": "Availability",
    "cardTitle": "Materials with no availability",
    "tagCheck": "Check",
    "tagLoading": "Loading...",
    "table": {
      "noDataText": "No materials without availability",
      "errorText": "Failed to load materials",
      "headerCode": "Code",
      "headerProductName": "Product name",
      "headerCountry": "Country",
      "rowButtonText": "Show",
      "errorWithProduct": "Product not found!"
    }
  },
  "reportsPage": {
    "title": "Reports",
    "menuItemLabel": "Reports",
    "assetReportButton": "Active leased devices",
    "userReportButton": "Users",
    "organizationReportButton": "Organizations",
    "salesChannelBundlesReportButton": "Sales channel bundles",
    "bundlesReportButton": "Bundles",
    "productVariantsReportButton": "Product variants",
    "eolReportButton": "End-of-lease decisions",
    "eolReportDateRangeLabel": "Select for which period to generate end-of-lease report",
    "orderHistoryReportButton": "Order history",
    "orderHistoryReportDateRangeLabel": "Select for which period to generate order history report",
    "financeSyncReportButton": "Telia Finance sync requests",
    "dateErrorMessage": "Something is wrong with dates. Please select again."
  }
}
